import React from 'react'
import { Layout, Row, Col, Steps } from "antd";
import styled from 'styled-components';

const StyledDiv = styled.div`
    font-family: "Poppins", sans-serif;
`;

const { Content } = Layout;
const { Step } = Steps;

const observationSteps = [
    {
      title: "General Information",

    },
    {
      title: "Actions",
    },
];

export const Breadcrumb = ({currentSection, status}) => {
    return (
        <Col
            span={6}
            className="breadcrumbContainer"
            style={{
                backgroundColor: "#FBFBFB"
            }}
        >
            <Content
                style={{
                    backgroundColor: "transparent",
                }}
            >
                <Row
                    style={{
                        marginTop: "30px",
                        marginBottom: "8px",
                    }}
                >
                    <Col
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                        span={24}
                    >
                        <StyledDiv>
                            <button className="breadcrumbButton" disabled={true}>{currentSection}</button>
                        </StyledDiv>
                        
                    </Col>
                </Row>

                <Row
                >
                    <Col
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                        span={24}
                    >
                        
                        <StyledDiv style={{position: "relative"}}>
                            <p style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                margin: "0"
                            
                            }}>{observationSteps[currentSection - 1].title}</p>
                        </StyledDiv>
                        
                    </Col>
                </Row>
            </Content>
            <Content style={{
                backgroundColor: "transparent",
                paddingTop: "20px",
                display: "flex",
                justifyContent: "center",
            }}>
                <StyledDiv
                >
                    <Steps
                        direction="vertical"
                        size="small"
                        current={currentSection - 1}
                        style={{
                            width: '100%',
                            margin: '0 auto',
                            paddingLeft: "30px",
                            paddingRight: "30px"
                        }}
                    >
                    
                        {observationSteps.map((item, index) => (
                            
                            <Step
                                key={item.title}
                                title={item.title}
                                status={status[index]}
                                
                            />
                        ))}
                    
                    </Steps>
                </StyledDiv>
            </Content>

            
        
        </Col>
    )
}
